import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const USERNAME = 'username'
export const PASSWORD = 'password'
export const LOGIN = 'login'
export const REQUIRED_FIELDS = 'required fields'
export const ACCESS_EXPIRED = 'access expired'
export const ERROR_CONNECTING = 'error connecting'
export const PRIVACY = 'PRIVACY_POLICY'

export default {
  [PORTUGUESE]: {
    [USERNAME]: 'Nome do usuário',
    [PASSWORD]: 'Senha',
    [LOGIN]: 'Entrar',
    [REQUIRED_FIELDS]: 'Por favor preencha todos os campos obrigatórios',
    [ACCESS_EXPIRED]: 'SEU ACESSO EXPIROU, FAÇA LOGIN NOVAMENTE PARA ATIVÁ-LO',
    [ERROR_CONNECTING]: 'Erro ao conectar, tente novamente',
    [PRIVACY]: 'Política de Privacidade',
  },

  [ENGLISH]: {
    [USERNAME]: 'Username',
    [PASSWORD]: 'Password',
    [LOGIN]: 'Login',
    [REQUIRED_FIELDS]: 'Please fill in all the required fields',
    [ACCESS_EXPIRED]: 'YOUR ACCESS HAS EXPIRED, LOG IN AGAIN TO ACTIVATE IT',
    [ERROR_CONNECTING]: 'Error connecting, try again',
    [PRIVACY]: 'Privacy Policy',
  },

  [SPANISH]: {
    [USERNAME]: 'Nombre de usuario',
    [PASSWORD]: 'Clave',
    [LOGIN]: 'Iniciar',
    [REQUIRED_FIELDS]: 'Por favor, rellene todos los campos obligatorios',
    [ACCESS_EXPIRED]: 'SU ACCESO HA CADUCADO, INGRESE DE NUEVO PARA ACTIVARLO',
    [ERROR_CONNECTING]: 'Error al conectar, inténtalo de nuevo',
    [PRIVACY]: 'Política de Privacidad',
  },
}
